import React, { useState } from "react";
import { requestStatusProps } from "../../../../../utils/types";
import UpdateButton from "../../../buttons/manage-jdl/updateButton";

interface updateDataProps {
    id : number,
    name : string,
    endPoint : string
}

const UpdateModal : React.FC<updateDataProps> = ({id, name, endPoint}) =>{

    const [domainName, setDomainName] = useState<string>(name);
    const [updateStatus, setUpdateStatus] = useState<requestStatusProps>({
        success : false,
        message : ''
    });
    
    return (
        <div>
            <div>
                Update {name}
            </div>
        <div>
            <form>
                <div className={updateStatus.success ? 'text-green-600' : 'text-red-500'}>
                    {updateStatus.message}
                </div>
                <div className="input-container flex flex-col">
                    <input type="text" value={domainName} onChange={(e) => setDomainName(e.target.value)} className="text-box" />
                </div>
                <UpdateButton inputName={domainName} id={id} onSubmit={(value)=>setUpdateStatus(value)} endpoint={endPoint} />
            </form>
        </div>
    </div>
    )
}

export default UpdateModal;